export function WordMark () {
    return (
        <section className="brand-banner">
            <div className="brand-banner-word reveal">READAL</div>
            <div className="brand-banner-row container reveal delay-1">
            <span>Readal Systems</span>
            <span className="tagline">ERP • AI Automation • Cloud Solutions • Custom Software Development</span>
            </div>
        </section>
    )
}